import React, { useEffect, useMemo, useState } from "react";

const API_ROOT = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");

function formatDate(val) {
  if (!val || val === "0000-00-00") return "";
  const d = new Date(val);
  if (isNaN(d)) return "";
  return d.toLocaleDateString("en-GB");
}

export default function SpecialRoles() {
  const localUser = useMemo(() => {
    try { return JSON.parse(localStorage.getItem("user") || "null"); } catch { return null; }
  }, []);

  const moduleId = parseInt(localUser?.moduleId, 10);

  const [departments, setDepartments] = useState([]);
  const [modules,     setModules]     = useState([]);
  const [employees,   setEmployees]   = useState([]);
  const [roleList,    setRoleList]    = useState([]);

  const [departmentID, setDepartmentID] = useState("");
  const [selectedMod,  setSelectedMod]  = useState("");
  const [fromDate,     setFromDate]     = useState("");
  const [employeeID,   setEmployeeID]   = useState("");

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });

  const fetchRoleList = () => {
    fetch(`${API_ROOT}/api/employees/special-roles/list`)
      .then(r => r.json())
      .then(data => setRoleList(Array.isArray(data) ? data : []))
      .catch(() => {});
  };

  useEffect(() => {
    if (moduleId !== 4) return;

    fetch(`${API_ROOT}/api/directory/departments`)
      .then(r => r.json())
      .then(data => setDepartments(Array.isArray(data) ? data : []))
      .catch(() => {});

    fetch(`${API_ROOT}/api/employees/special-roles/modules`)
      .then(r => r.json())
      .then(data => setModules(Array.isArray(data) ? data : []))
      .catch(() => {});

    fetch(`${API_ROOT}/api/employees/special-roles/employees`)
      .then(r => r.json())
      .then(data => setEmployees(Array.isArray(data) ? data : []))
      .catch(() => {});

    fetchRoleList();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (moduleId !== 4) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger">Unauthorized access Or Session Timed out.</div>
      </div>
    );
  }

  const handleSave = async (e) => {
    e.preventDefault();
    if (!departmentID || !selectedMod || !fromDate || !employeeID) {
      setMessage({ text: "Invalid input. Please fill all fields correctly.", type: "danger" });
      return;
    }
    setLoading(true);
    setMessage({ text: "", type: "" });
    try {
      const res  = await fetch(`${API_ROOT}/api/employees/special-roles/save`, {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify({
          employeeID,
          departmentID,
          moduleID: selectedMod,
          fromDate,
        }),
      });
      const data = await res.json();
      if (res.ok) {
        setMessage({ text: data.message || "Saved.", type: "success" });
        setDepartmentID(""); setSelectedMod(""); setFromDate(""); setEmployeeID("");
        fetchRoleList();
      } else {
        setMessage({ text: data.message || "Error saving.", type: "danger" });
      }
    } catch {
      setMessage({ text: "Error saving special role.", type: "danger" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid mt-3">
      <h4 className="ctitle">Special Roles</h4>

      {message.text && (
        <div className={`alert alert-${message.type} alert-dismissible`}>
          {message.text}
          <button type="button" className="btn-close" onClick={() => setMessage({ text: "", type: "" })} />
        </div>
      )}

      <form className="row g-2 align-items-end mb-3" onSubmit={handleSave}>
        <div className="col-md-4">
          <label className="form-label">Select Department</label>
          <select
            className="form-select form-select-sm"
            value={departmentID}
            onChange={e => setDepartmentID(e.target.value)}
            required
          >
            <option value="">Select Department</option>
            {departments.map(d => (
              <option key={d.DepartmentID} value={d.DepartmentID}>{d.Department}</option>
            ))}
          </select>
        </div>

        <div className="col-md-3">
          <label className="form-label">Select Module</label>
          <select
            className="form-select form-select-sm"
            value={selectedMod}
            onChange={e => setSelectedMod(e.target.value)}
            required
          >
            <option value="">Select Module</option>
            {modules.map(m => (
              <option key={m.ModuleID} value={m.ModuleID}>{m.Module}</option>
            ))}
          </select>
        </div>

        <div className="col-md-2">
          <label className="form-label">From Date</label>
          <input
            className="form-control form-control-sm"
            type="date"
            value={fromDate}
            onChange={e => setFromDate(e.target.value)}
            required
          />
        </div>

        <div className="col-md-4">
          <label className="form-label">Select Employee</label>
          <select
            className="form-select form-select-sm"
            value={employeeID}
            onChange={e => setEmployeeID(e.target.value)}
            required
          >
            <option value="">Select Employee</option>
            {employees.map(emp => (
              <option key={emp.EmployeeID} value={emp.EmployeeID}>
                {emp.EmpName} — {emp.Department} — {emp.Designation}
              </option>
            ))}
          </select>
        </div>

        <div className="col-auto">
          <button className="btn btn-success btn-sm" type="submit" disabled={loading}>
            {loading ? "Saving..." : "Save"}
          </button>
        </div>
      </form>

      <hr />

      <h5>Special Roles</h5>
      <div className="table-responsive">
        <table className="table table-bordered table-sm align-middle" style={{ fontSize: '13px', whiteSpace: 'nowrap' }}>
          <thead style={{ '--bs-table-bg': '#008080', color: 'white' }}>
            <tr>
              <th>SNo</th>
              <th>Department</th>
              <th>Name</th>
              <th>Designation</th>
              <th>Role</th>
              <th>From Date</th>
              <th>To Date</th>
            </tr>
          </thead>
          <tbody>
            {roleList.length === 0 ? (
              <tr>
                <td colSpan={7} className="text-center text-muted py-2">No records found.</td>
              </tr>
            ) : (
              roleList.map((row, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{row.Department}</td>
                  <td>{row.EmpName}</td>
                  <td>{row.Designation}</td>
                  <td>{row.Module}</td>
                  <td>{formatDate(row.FromDate)}</td>
                  <td>{formatDate(row.ToDate)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
